module.exports = __webpack_public_path__ + "static/img/zhixin-logo3.1aba4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhixin-logo3.png
// module id = 6P9I
// module chunks = 13